module.exports = __webpack_public_path__ + "static/img/3104_phase_function_Paper_PointsHejduk_Prediction.4ff108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3104_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2m37
// module chunks = 0